export default "__VITE_ASSET__Be$0t3sV__"